import Vue from 'vue'
import axios from 'axios'

export default class BaseApiService {
   constructor() {
      this.client = axios.create({
         baseURL: process.env.VUE_APP_BASE_API_URL,
         json: true
      })
      this.exiting = false
   }

   // Anonymous API calls
   async executeAnon(method, resource, data) {      
      return this.client({
         method,
         url: resource,
         data
      }).then(req => {
         return req.data
      })
   }

   // Token based APIS
   async execute(method, resource, data) {
      const token = await Vue.prototype.$auth.Token()
      return this.client({
         method,
         url: resource,
         data,
         headers: {
            Authorization: `Bearer ${token}`
         }
      }).then(res => {
         return res.data
      }).catch(async (err) => {
         console.log('err ==', JSON.stringify(err))
         if ((err.status && err.status == 401) || (err.response && 401 === err.response.status)) { //UnAuthorized - kick'em out
            if (this.exiting == false) {
               this.exiting = true //make this section NOT rentrant
               await Vue.prototype.$swal(
                  "Session Timeout",
                  "It looks like your session on the site has timed out. Please log in again to resume...",
                  "warning"
               )
               .then((result) => {
                  Vue.prototype.$auth.logout();   
                  this.exiting = false            
               })
            }
            return
         }
         throw err
      })
   }

   // Download & Stream Documents to screen
   async apiStream(data) {
      //Check it out: https://stackoverflow.com/questions/65255649/load-pdf-from-server-and-embed-in-vue-app
      this.errors = ''
      const token = await Vue.prototype.$auth.Token()
      
      return this.client({
         method: 'post',
         url: 'document/Download',
         data: data,
         responseType: 'blob',
         headers: {
            Authorization: `Bearer ${token}`
         }
      }).then(response => {
         if (response.data.size == 0) {
            this.errors = "Download Error: File Empty"
         } else {
            const blob = new Blob([response.data])
            return URL.createObjectURL(blob)
         }
      }, (error) => {
         this.errors = "Download Stream Error: " + error
      })
   }

   // Download Documents
   async apiDownload(data, isAnon = false) {
      let label = data.Title
      if (data.Path=="DOCTYP_COMB_APP") {
         label = "CombinedContract.pdf"
      }
      let waitTimeMS = 1000 //1 seconds
      //Check it out: https://stackoverflow.com/questions/53772331/vue-html-js-how-to-download-a-file-to-browser-using-the-download-tag
      this.errors = ''

      let token
      if (!isAnon) {
         token = await Vue.prototype.$auth.Token()
      }
      
      return this.client({
            method: 'post',
            url: 'document/Download',
            data: data,
            responseType: 'blob',
            headers: {
               Authorization: `Bearer ${token}`
            }
      }).then(response => {
         if (response.data.size == 0) {
            this.errors = "Download Error: File Empty"
         } else {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.download = label
            link.click()

            setTimeout(() => {
               URL.revokeObjectURL(link.href)
               try {
                  document.removeChild(link);
               } catch (err) { 
                  // log err
               }
            }, waitTimeMS);
         }
      }, async (error) => {
         if ((error.status && error.status == 401) || (error.response && 401 === error.response.status)) { //UnAuthorized - kick'em out
            if (this.exiting == false) {
               this.exiting = true //make this section NOT rentrant
               await Vue.prototype.$swal(
                  "Session Timeout",
                  "It looks like your session on the site has timed out. Please log in again to resume...",
                  "warning"
               )
               .then((result) => {
                  Vue.prototype.$auth.logout();   
                  this.exiting = false            
               })
            }
            return
         }
         let responseObj = await error.response.data.text();
         this.errors = []
         this.errors.push(responseObj)         
      })
   }
}